import React, { useContext, useEffect, useState } from 'react'
// import { useFormik } from 'formik'
import { Box, Button, Center, Divider, Flex, FormControl, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useDisclosure, useToast } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import Loading from '../../../components/common/Loading'
import { IGetSurveyTemplates } from '../../../models/admin/Survey.model'
import { ICenter } from '../../../models/centers.model'
import { IAvailableCourse } from '../../../models/trainee-course.model'
import AdminHelpers from '../../../services/admin/admin.service'
import SurveyService from '../../../services/admin/survey.service'
import { getLocalUserProfile } from '../../../services/auth.service'
import coursesService from '../../../services/courses.service'
import { TemplateCodeContext } from '../../contextProvider/templateCodeProvider'
import Adminroutes from '../routes'


export const UseTemplate = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure()
    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)
    const [IdArray, setIdArray] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [surveyTemplates, setSurveyTemplates] = useState<IGetSurveyTemplates | any>([]);
    const [surveyTitle, setSurveyTitle] = useState('');
    const [courseId, setCourseId] = useState('');
    const [centerId, setCenterId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [courses, setCourses] = useState<IAvailableCourse | any>([]);
    const [centers, setCenters] = useState<ICenter | any>([]);
    const user: any = getLocalUserProfile();
    const [templateQuestions1, setTemplateQuestions1] = useState<Array<object>>([]);
    const [templateQuestions2, setTemplateQuestions2] = useState<any>([]);
    const [templateQuestions3, setTemplateQuestions3] = useState<any>([]);
    const [templateQuestions4, setTemplateQuestions4] = useState<any>([]);
    const params:any = useParams();
    const [tabIndex, setTabIndex] = useState<any>(0);
    const { templateCode1, templateCode2, templateCode3, templateCode4 } = useContext(TemplateCodeContext);
    const selectedTemplateCode = tabIndex === 0 ? templateCode1 : tabIndex === 1 ? templateCode2 : tabIndex === 2 ? templateCode3 : templateCode4;
    const tabIndexx:any = sessionStorage.getItem("tabIndex");

    const handleNext = () => {
        if (tabIndex === 3) {
        return;
        }
        setTabIndex(tabIndex + 1);
    };

    const handlePrev = () => {
        if (tabIndex === 0) {
        return;
        }
        setTabIndex(tabIndex - 1);
    };

    useEffect(() => {
        // const tabIndexx = sessionStorage.getItem("tabIndex");
        if (tabIndexx){
            setTabIndex(parseInt(tabIndexx));
        }else{
            setTabIndex(0);
        }
        
        if (selectedTemplateCode !== "") {
            
            SurveyService.getSurveyTemplates().then(
                (res) => {
                    setSurveyTemplates(res.data)
                    const resultObj = res.data.reduce((acc:any, item:any) => {
                        const existing = acc[item.code] || [];
                        existing.push(item.survey_question_id);
                        acc[item.code] = existing
                        return acc;
                    }, {})
                    if (resultObj){
                        
                        const filteredResult = Object.entries(resultObj).filter(([key, value]) => key === selectedTemplateCode);
                        
                        setIdArray(filteredResult[0][1])
                        getQuestions(filteredResult[0][1]);
                    }
                })
        }
        coursesService.getAvailableCourses().then(
            (res) => {
                const  realCourses = res.filter((each) => each.course !== null)
          
                setCourses(realCourses);
            }
        )
        AdminHelpers.getAllCenters().then(
            (res) => {
                setCenters(res.data);
                // 
            }
        )
        
    }, []);

    const getQuestions = async (IdArray: any) => {
        const questions =  await Promise.all(IdArray.map(async (id: string) => {
            const res = await SurveyService.getSurveyQuestion(id);
            return res.data;
        }))
        // const tabIndexx = sessionStorage.getItem("tabIndex");
        switch (parseInt(tabIndexx)) {
        case 0:
            setTemplateQuestions1(questions);
            
            break;
        case 1:
            setTemplateQuestions2(questions);
            
            break;
        case 2:
            setTemplateQuestions3(questions);
            
            break;
        case 3:
            setTemplateQuestions4(questions);
            
            break;
        default:
            break;
        }
        if (questions.length > 0) 
            setLoading(false);
    }
    // handle create survey
    const handleCreateSurvey = async () => {
            const createSurveyDetails: any = {
                title: surveyTitle,
                user_id: user?.id.toString(),
                course_availability_id: courseId,
                course_survey_template_code: templateCode1,
                trainer_survey_template_code: templateCode2,
                centre_survey_template_code: templateCode3,
                other_survey_template_code: templateCode4,
                start_date: startDate,
                end_date: endDate,
                status: 'pending',
            }
            try {
                const createSurveyResponse = await SurveyService.createSurvey(createSurveyDetails)
                if (createSurveyResponse.status === 'success') {
                    
                    toast({
                        title: "Survey",
                        description: "Survey created successfully",
                        status: "success",
                    })
                    navigate(Adminroutes.ViewSurvey)

                }
            } catch (error: any) {
                
                toast({
                    title: "Survey",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
    }

    return (
        <>
            <Flex bg="white" height="65px" width="100hw" justifyContent="flex-end" alignItems="center" px="2rem" direction="row" >
                    {/* <Input placeholder='Enter Survey Title' size='md' border='none' width="25%" variant="unstyled" value={surveyTitle} onChange={(event)=>setSurveyTitle(event.target.value)}/> */}
                    {/* <HStack spacing="1.2rem" fontSize="14px" color="red">
                        <Link to={Adminroutes.Survey}>Exit</Link>
                    </HStack> */}
                <Flex bg="white" fontSize="14px" height="65px" width="100hw" justifyContent="flex-end" alignItems="center" px="2rem" direction="row" gap="1rem">
                    <Text as="button" onClick={() => navigate(Adminroutes.Survey)} color="red">Exit</Text>
                    <Button colorScheme="red"
                        borderRadius="4px"
                        fontSize="13px"
                        fontWeight="600"
                        // onClick={() => handleCreateSurvey()}
                        onClick={onOpen}
                    >Create Survey
                    </Button>
                </Flex>
            </Flex>
            <Modal
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
            >
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Create Survey</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
            <FormControl mt={4}>
                    <FormLabel>Enter Survey Title</FormLabel>
                    <Input
                        placeholder="survey title"
                        size="md"
                        type="text"
                        value={surveyTitle} 
                        onChange={(event)=>setSurveyTitle(event.target.value)}
                    />
                </FormControl>
                <FormControl mt={4}>
                    <FormLabel>Select Course for Survey</FormLabel>
                    <Select placeholder='please select an option' fontSize="14px" value={courseId} onChange={(event) => setCourseId(event.target.value)}>
                        {
                            courses.map((each: any, index: number) =>
                                <option key={index} value={each.id}>{each.course.name.slice(0,32)}...</option>
                            )
                        }
                    </Select>
                </FormControl>
                <FormControl mt={4}>
                    <FormLabel>Start date</FormLabel>
                    <Input
                        placeholder="Select start date"
                        size="md"
                        type="datetime-local"
                        value={startDate} 
                        onChange={(event)=>setStartDate(event.target.value)}
                    />
                </FormControl>
                <FormControl mt={4}>
                    <FormLabel>End date</FormLabel>
                    <Input
                        placeholder="Select due date"
                        size="md"
                        type="datetime-local"
                        value={endDate} 
                        onChange={(event)=>setEndDate(event.target.value)}
                    />
                </FormControl>
            </ModalBody>

                <ModalFooter>
                    <Button colorScheme="red"
                        borderRadius="4px"
                        fontSize="13px"
                        fontWeight="600"
                        onClick={() => handleCreateSurvey()}
                    >Submit
                    </Button>
                </ModalFooter>
            </ModalContent>
            </Modal>
            <Center bg="#F9F8F8" width="100hw" minHeight="90vh">
                <Tabs isLazy bg="white" width="55%" mt={50} mb="100px" height="auto" colorScheme="red" variant="enclosed" onChange={(index) => setTabIndex(index)} index={tabIndex}>
                    <TabList width="full" display="flex" justifyContent="space-evenly" alignItems="center" pt="0.5rem">
                        <Tab  fontWeight="700" fontSize="16px">Training Programme Evaluation</Tab>
                        <Tab  fontWeight="700" fontSize="16px">Trainer Evaluation</Tab>
                        <Tab  fontWeight="700" fontSize="16px">Logistics and Accomodation</Tab>
                        <Tab  fontWeight="700" fontSize="16px">Others</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel display="flex" flexDirection="column" padding="1rem" width="100%" justifyContent="center" alignContent="center" >
                            <Text textAlign="center" fontWeight="700" marginY="1.2rem" marginLeft="1rem">TRAINING PROGRAMME EVALUATION</Text>
                            {
                                templateCode1 !== "" ?
                                    <Flex width="68%" mx="auto" direction="column" justifyContent="center" alignItems="center" height="auto" gap="0.6rem" paddingBottom="3rem">
                                        {
                                            loading ? <Loading /> :
                                                templateQuestions1 != null?
                                                    templateQuestions1?.map((each: any, index: number) => (
                                                        <Box key={index} width="100%" height="auto" mt="0.5rem"   px="2.5rem" py="0.3rem">
                                                            <HStack spacing="8px">
                                                                <Text>{index + 1}.</Text>
                                                                <Text width="100%"
                                                                    fontWeight="700"
                                                                    fontSize="16px"
                                                                    lineHeight="22px">{each.question}</Text>
                                                            </HStack>
                                                            <Flex justifyContent="space-between" mt="1rem">
                                                                <Stack spacing="14px">
                                                                    <HStack fontSize="14px">
                                                                        <Text>1.</Text>
                                                                        <Text>{each.label1}</Text>
                                                                    </HStack>
                                                                    <HStack fontSize="14px">
                                                                        <Text>5.</Text>
                                                                        <Text>{each.label2}</Text>
                                                                    </HStack>
                                                                </Stack>
                                                            </Flex>
                                                            <Divider mt="0.8rem" mb="0.8rem" />
                                                        </Box>
                                                    ))
                                                    : ''
                                        }
                                        <Flex width="100%" justifyContent="flex-end">
                                            <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                justifySelf="flex-end"
                                                marginLeft="auto"
                                                onClick={handleNext}>NEXT
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    :
                                    <Center bgColor="white" height="40rem" width="60%" display="flex" flexDirection="column" mx="auto">
                                        <Text>Please select Template for Training Programme Evaluation</Text>
                                        <Button colorScheme="red"
                                            borderRadius="4px"
                                            fontSize="13px"
                                            fontWeight="600"
                                            marginTop="1.4rem"
                                            onClick={() => {
                                                navigate(Adminroutes.SurveyTemplateLink(tabIndex));
                                            }}>
                                            Select Template
                                        </Button>
                                    </Center>
                            }
                        </TabPanel>
                        <TabPanel display="flex" flexDirection="column" padding="1rem" width="100%" justifyContent="center" alignContent="center" >
                            <Text textAlign="center" fontWeight="700" marginY="1.2rem" marginLeft="1rem">TRAINER EVALUATION</Text>
                            {
                                templateCode2 !== "" ?
                                    <Flex width="68%" mx="auto" direction="column" justifyContent="center" alignItems="center" height="auto" gap="0.6rem" paddingBottom="3rem">
                                        {
                                            loading ? <Loading /> :
                                                templateQuestions2.length != null?
                                                    templateQuestions2?.map((each: any, index: number) => (
                                                        <Box key={index} width="100%" height="auto" mt="0.5rem"  px="2.5rem" py="0.3rem">
                                                            <HStack spacing="8px">
                                                                <Text>{index + 1}.</Text>
                                                                <Text width="100%"
                                                                    fontWeight="700"
                                                                    fontSize="16px"
                                                                    lineHeight="22px">{each.question}</Text>
                                                            </HStack>
                                                            <Flex justifyContent="space-between" mt="1rem">
                                                                <Stack spacing="14px">
                                                                    <HStack fontSize="14px">
                                                                        <Text>1.</Text>
                                                                        <Text>{each.label1}</Text>
                                                                    </HStack>
                                                                    <HStack fontSize="14px">
                                                                        <Text>5.</Text>
                                                                        <Text>{each.label2}</Text>
                                                                    </HStack>
                                                                </Stack>
                                                            </Flex>
                                                            <Divider mt="0.8rem" mb="0.8rem" />
                                                        </Box>
                                                    ))
                                                    : ''
                                        }
                                        <Flex width="100%" justifyContent="space-between">
                                        <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                onClick={handlePrev}>PREVIOUS
                                            </Button>
                                            <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                onClick={handleNext}>NEXT
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    :
                                    <Center bgColor="white" height="40rem" width="60%" display="flex" flexDirection="column" mx="auto">
                                        <Text>Please select Template for Trainer Evaluation</Text>
                                        <Button colorScheme="red"
                                            borderRadius="4px"
                                            fontSize="13px"
                                            fontWeight="600"
                                            marginTop="1.4rem"
                                            onClick={() => {
                                                navigate(Adminroutes.SurveyTemplateLink(tabIndex));
                                            }}>
                                            Select Template
                                        </Button>
                                    </Center>
                            }
                        </TabPanel>
                        <TabPanel display="flex" flexDirection="column" padding="1rem" width="100%" justifyContent="center" alignContent="center" >
                            <Text fontWeight="700" textAlign="center" marginY="1.2rem" marginLeft="1rem">LOGISTICS & ACCOMODATION</Text>
                            {
                                templateCode3 !== "" ?
                                    <Flex width="68%" mx="auto" direction="column" justifyContent="center" alignItems="center" height="auto" gap="0.6rem" paddingBottom="3rem">
                                        {
                                            loading ? <Loading /> :
                                                templateQuestions3.length != null?
                                                    templateQuestions3?.map((each: any, index: number) => (
                                                        <Box key={index} width="100%" height="auto" mt="1rem"  px="2.5rem" py="0.3rem">
                                                            <HStack spacing="8px">
                                                                <Text>{index + 1}.</Text>
                                                                <Text width="100%"
                                                                    fontWeight="700"
                                                                    fontSize="16px"
                                                                    lineHeight="22px">{each.question}</Text>
                                                            </HStack>
                                                            <Flex justifyContent="space-between" mt="1rem">
                                                                <Stack spacing="14px">
                                                                    <HStack fontSize="14px">
                                                                        <Text>1.</Text>
                                                                        <Text>{each.label1}</Text>
                                                                    </HStack>
                                                                    <HStack fontSize="14px">
                                                                        <Text>5.</Text>
                                                                        <Text>{each.label2}</Text>
                                                                    </HStack>
                                                                </Stack>
                                                            </Flex>
                                                            <Divider mt="0.8rem" mb="0.8rem" />
                                                        </Box>
                                                    ))
                                                    : ''
                                        }
                                        <Flex width="100%" justifyContent="space-between">
                                            <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                onClick={handlePrev}>PREVIOUS
                                            </Button>
                                            
                                            <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                onClick={handleNext}>NEXT
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    :
                                    <Center bgColor="white" height="40rem" width="60%" display="flex" flexDirection="column" mx="auto">
                                        <Text>Please select Template for Logistics & Accomodation Evaluation</Text>
                                        <Button colorScheme="red"
                                            borderRadius="4px"
                                            fontSize="13px"
                                            fontWeight="600"
                                            marginTop="1.4rem"
                                            onClick={() => {
                                                navigate(Adminroutes.SurveyTemplateLink(tabIndex));
                                            }}>
                                            Select Template
                                        </Button>
                                    </Center>
                            }
                        </TabPanel>
                        <TabPanel display="flex" flexDirection="column" padding="1rem" width="100%" justifyContent="center" alignContent="center" >
                            <Text fontWeight="700" marginY="1.2rem" marginLeft="1rem" textAlign="center">OTHERS</Text>
                            {
                                templateCode4 !== "" ?
                                    <Flex width="68%" mx="auto" direction="column" justifyContent="center" alignItems="center" height="auto" gap="0.6rem" paddingBottom="3rem">
                                        {
                                            loading ? <Loading /> :
                                                templateQuestions4.length != null ?
                                                    templateQuestions4?.map((each: any, index: number) => (
                                                        <Box key={index} width="100%" height="auto" mt="1rem" px="2.5rem" py="0.5rem">
                                                            <HStack spacing="8px">
                                                                <Text>{index + 1}.</Text>
                                                                <Text width="100%"
                                                                    fontWeight="700"
                                                                    fontSize="16px"
                                                                    lineHeight="22px">{each.question}</Text>
                                                            </HStack>
                                                            <Flex justifyContent="space-between" mt="1rem">
                                                                <Stack spacing="14px">
                                                                    <HStack fontSize="14px">
                                                                        <Text>1.</Text>
                                                                        <Text>{each.label1}</Text>
                                                                    </HStack>
                                                                    <HStack fontSize="14px">
                                                                        <Text>5.</Text>
                                                                        <Text>{each.label2}</Text>
                                                                    </HStack>
                                                                </Stack>
                                                            </Flex>
                                                            <Divider mt="0.8rem" mb="0.8rem" />
                                                        </Box>
                                                    ))
                                                    : ''
                                        }
                                        <Flex width="100%" justifyContent="flex-start">
                                            <Button colorScheme="red"
                                                borderRadius="4px"
                                                fontSize="13px"
                                                fontWeight="600"
                                                marginTop="1.4rem"
                                                justifySelf="flex-end"
                                                marginRight="auto"
                                                onClick={handlePrev}>PREVIOUS
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    :
                                    <Center bgColor="white" height="40rem" width="60%" display="flex" flexDirection="column" mx="auto">
                                        <Text>Please select Template for Other Evaluations</Text>
                                        <Button colorScheme="red"
                                            borderRadius="4px"
                                            fontSize="13px"
                                            fontWeight="600"
                                            marginTop="1.4rem"
                                            onClick={() => {
                                                navigate(Adminroutes.SurveyTemplateLink(tabIndex));
                                            }}>
                                            Select Template
                                        </Button>
                                    </Center>
                            }
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Center>
        </>
    )
}
export default UseTemplate
